export default "__VITE_ASSET__4c1eab62__"